const getActorName = (user = {}) => user?.displayName || user?.name || 'Unknown';
const getActorEmail = (user = {}) => user?.email || getActorName(user);

export const buildQuoteAuditFields = (user, timestamp = new Date().toISOString()) => ({
  updatedAt: timestamp,
  updatedBy: getActorName(user),
  updatedByEmail: getActorEmail(user),
  updatedByUid: user?.uid || '',
});
